import React from 'react';

const CreditsAlliance = () => {
  return <h1>CreditsAlliance Page</h1>;
};

export default CreditsAlliance;
